import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export function usePoll(url, ms = 0, deps = []) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const alive = useRef(true);
  const load = useCallback(async () => {
    if (!url) return;
    try {
      const r = await api.get(url);
      if (alive.current) { setData(r.data); setError(null); }
    } catch (e) {
      if (alive.current) setError(e);
    } finally {
      if (alive.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => {
    alive.current = true;
    setLoading(true);
    load();
    const t = ms ? setInterval(load, ms) : null;
    return () => { alive.current = false; t && clearInterval(t); };
  }, [load, ms]);
  return { data, error, loading, reload: load };
}
